export default __webpack_public_path__ + "static/media/teamwork.aa71db2e.svg";